// Bilingual content dictionary. Keep keys synchronized between `en` and `ar`.
export const translations = {
  en: {
    dir: "ltr",
    nav: {
      home: "Home",
      services: "Services",
      beforeAfter: "Before & After",
      howItWorks: "How It Works",
      faq: "FAQ",
      location: "Location",
      quote: "Free Quote",
      contact: "Contact",
    },
    common: {
      whatsapp: "WhatsApp",
      call: "Call",
      callNow: "Call Now",
      whatsappNow: "WhatsApp Now",
      sendOnWhatsApp: "Send on WhatsApp",
      sendPhotosOnWhatsApp: "Send Photos on WhatsApp",
      getDirections: "Get Directions",
      openInGoogleMaps: "Open in Google Maps",
      readMore: "Read more",
      readLess: "Show less",
      placeholder: "Placeholder",
      langLabel: "عربي",
    },
    hero: {
      eyebrow: "Paintless Dent Repair — Kuwait",
      title: "Fix Dents Without Repainting",
      subtitle:
        "Dent Xpress specializes in paintless dent repair in Kuwait, helping preserve your car's original factory paint whenever possible.",
      sincePill: "Trusted in Kuwait since 2005",
      proofLabel: "Live proof",
    },
    stats: {
      items: [
        { label: "Established", value: "2005", note: "20+ years specialising in PDR" },
        { label: "Specialty", value: "Paintless", note: "Factory paint preserved when possible" },
        { label: "Google", value: "4.2★", note: "Real verified customer reviews" },
        { label: "Turnaround", value: "≈30 min", note: "Many small dents same-visit" },
      ],
    },
    brands: {
      label: "We work on all car brands",
    },
    trust: [
      "Paintless repair",
      "Factory paint preserved when possible",
      "Fast WhatsApp assessment",
      "Shuwaikh, Kuwait",
    ],
    why: {
      eyebrow: "Why us",
      title: "Why Choose Dent Xpress?",
      heritageLabel: "Heritage",
      heritageHeadline: "Years of paintless dent specialism in Kuwait",
      heritageCopy:
        "Two decades of careful, honest work — focused entirely on removing dents without repainting and preserving the original factory finish.",
      estLabel: "Established",
      points: [
        { t: "Paintless dent specialists", d: "Our entire focus is removing dents without repainting." },
        { t: "Factory paint preserved", d: "Original paint kept intact whenever the case allows." },
        { t: "Fast WhatsApp assessment", d: "Send clear photos and get a quick, honest opinion." },
        { t: "Clean professional workshop", d: "Organized Shuwaikh workshop built for precision work." },
        { t: "Experienced technicians", d: "Skilled hands trained on modern PDR techniques." },
        { t: "Trusted in Kuwait since 2005", d: "Two decades of careful, honest work for local drivers." },
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Our Services",
      items: [
        { t: "Paintless Dent Repair", d: "Dent removal without repainting when the panel allows it.", icon: "Hammer" },
        { t: "Door Dings", d: "Small parking-lot dings removed cleanly, no paint disturbed.", icon: "Car" },
        { t: "Minor Dents", d: "Light dents on doors, fenders, and panels.", icon: "CircleDot" },
        { t: "Parking Dents", d: "Shopping carts, doors, bumpers — corrected without paint.", icon: "ParkingSquare" },
        { t: "Hail-Type Dents", d: "Multiple round dents across the body.", icon: "CloudHail" },
        { t: "Pre-Sale Appearance", d: "Freshen the body before selling your car.", icon: "Tag" },
        { t: "Photo Dent Assessment", d: "Send photos on WhatsApp, we advise honestly.", icon: "ImageDown" },
      ],
    },
    how: {
      eyebrow: "Process",
      title: "How It Works",
      steps: [
        { t: "Send clear photos", d: "Send clear photos of the dent on WhatsApp." },
        { t: "We assess honestly", d: "We assess if paintless repair is possible." },
        { t: "Visit or book a time", d: "Visit the workshop or book a time." },
        { t: "We repair without paint", d: "Your car is repaired without repainting when suitable." },
      ],
    },
    gallery: {
      eyebrow: "Proof of work",
      title: "Before & After",
      case: "Case",
      before: "Before",
      after: "After",
      dragHint: "Drag to compare",
      ctaLine: "Have a similar dent? Send us photos for assessment.",
      cta: "Send on WhatsApp",
      uploadingNote: "More cases coming soon — upload in progress.",
      casesLabel: "real cases",
    },
    videos: {
      eyebrow: "On camera",
      title: "Repair Results",
      subtitle: "Short clips showing the repair process and the finished panel.",
      caseLabel: "Case",
    },
    when: {
      eyebrow: "What's possible",
      title: "When Paintless Repair Works Best",
      copy: "Paintless dent repair works best when the paint is still intact, the panel is accessible, and the dent or light impact is not too sharp or stretched. Not every dent can be repaired 100%, but we will always assess honestly before starting.",
      chips: ["Paint intact", "Panel accessible", "Not too sharp", "Not stretched"],
    },
    reviews: {
      eyebrow: "Reputation",
      title: "What Customers Say",
      subtitle: "Trusted by car owners in Kuwait.",
      verifiedBadge: "Verified 5-star reviews from Google",
      placeholderBadge: "Editable placeholder",
      placeholderNote:
        "Real 5-star Google reviews will be added here. Cards below are editable placeholders only.",
      cta: "See all reviews on Google",
      placeholders: [
        { name: "Placeholder", text: "Replace this card with a real 5-star Google review." },
        { name: "Placeholder", text: "Replace this card with a real 5-star Google review." },
        { name: "Placeholder", text: "Replace this card with a real 5-star Google review." },
      ],
    },
    location: {
      eyebrow: "Find us",
      title: "Visit Dent Xpress",
      subtitle: "Nasser Center, Shop 33, Shuwaikh, Kuwait",
      hoursTitle: "Opening Hours",
      todayLabel: "Today",
      closed: "Closed",
      ramadanLabel: "Ramadan Hours",
    },
    faq: {
      eyebrow: "Answers",
      title: "Frequently Asked Questions",
      items: [
        { q: "What is paintless dent repair?", a: "It is a method of removing dents and light impacts without repainting the panel, when the paint and dent condition allow it." },
        { q: "Will my car need repainting?", a: "Not always. If the paint is intact and the dent is suitable, we can often repair it without repainting." },
        { q: "Can every dent be fixed?", a: "No. Some dents are too sharp, stretched, or damaged. We assess each case honestly before starting." },
        { q: "How long does repair take?", a: "It depends on the size, depth, and location of the dent. Many small dents can be repaired quickly." },
        { q: "Can I send photos first?", a: "Yes. Send clear photos on WhatsApp to 55787747 and we will advise you." },
        { q: "Do you repair scratches or only dents?", a: "Our specialty is dent repair without painting. Scratches may require a different repair method." },
      ],
    },
    quote: {
      eyebrow: "Free Quote",
      title: "Get a Free Quote",
      subtitle:
        "Tell us about your dent and attach photos — we'll review it and get back to you with an honest assessment.",
      nameLabel: "Your name",
      namePh: "e.g. Ahmad",
      phoneLabel: "Phone / WhatsApp number",
      phonePh: "e.g. 55787747",
      carLabel: "Car make & model",
      carPh: "e.g. Toyota Camry 2022",
      descLabel: "Describe the dent",
      descPh: "Where is the dent? How big is it? (door, fender, bonnet...)",
      photosLabel: "Photos of the dent (optional)",
      photosHint: "Up to 3 photos, max 10MB each",
      addPhotos: "Add photos",
      submit: "Request Free Quote",
      submitting: "Sending...",
      successTitle: "Thank you! Request received",
      successText:
        "We'll review your dent and contact you shortly. For the fastest response, continue on WhatsApp:",
      continueWhatsApp: "Continue on WhatsApp",
      newRequest: "Send another request",
      errorGeneric: "Something went wrong. Please try again or contact us on WhatsApp.",
      errorPhotos: "You can attach up to 3 photos (max 10MB each).",
      requiredNote: "Name and phone are required.",
    },
    contact: {
      eyebrow: "Start",
      title: "Send Photos for Assessment",
      subtitle: "Send us clear photos of the dent and we'll advise you.",
      instagram: "Instagram",
      shopLabel: "Shop",
    },
    footer: {
      tagline: "Paintless Dent Repair Specialist in Kuwait",
      rights: "All rights reserved.",
    },
  },
  ar: {
    dir: "rtl",
    nav: {
      home: "الرئيسية",
      services: "الخدمات",
      beforeAfter: "قبل وبعد",
      howItWorks: "طريقة العمل",
      faq: "الأسئلة",
      location: "الموقع",
      quote: "تقييم مجاني",
      contact: "تواصل معنا",
    },
    common: {
      whatsapp: "واتساب",
      call: "اتصال",
      callNow: "اتصل الآن",
      whatsappNow: "واتساب الآن",
      sendOnWhatsApp: "أرسل على واتساب",
      sendPhotosOnWhatsApp: "أرسل الصور على واتساب",
      getDirections: "افتح الموقع",
      openInGoogleMaps: "افتح في خرائط Google",
      readMore: "اقرأ المزيد",
      readLess: "عرض أقل",
      placeholder: "عنصر مؤقت",
      langLabel: "EN",
    },
    hero: {
      eyebrow: "إزالة الضربات بدون صبغ — الكويت",
      title: "إزالة الضربات بدون صبغ",
      subtitle:
        "دنت إكسبرس متخصصون في إزالة ضربات السيارات بدون صبغ في الكويت، مع الحفاظ على صبغ الوكالة متى ما كان الإصلاح ممكن.",
      sincePill: "موثوقون في الكويت منذ 2005",
      proofLabel: "نتيجة حقيقية",
    },
    stats: {
      items: [
        { label: "تأسس", value: "2005", note: "أكثر من ٢٠ سنة في إصلاح الضربات بدون صبغ" },
        { label: "التخصص", value: "بدون صبغ", note: "نحافظ على صبغ الوكالة متى ما أمكن" },
        { label: "Google", value: "4.2★", note: "تقييمات حقيقية من عملاء حقيقيين" },
        { label: "السرعة", value: "≈٣٠ دقيقة", note: "كثير من الضربات الصغيرة بنفس الزيارة" },
      ],
    },
    brands: {
      label: "نشتغل على جميع أنواع السيارات",
    },
    trust: [
      "إصلاح بدون صبغ",
      "نحافظ على صبغ الوكالة متى ما أمكن",
      "تقييم سريع عبر واتساب",
      "الشويخ، الكويت",
    ],
    why: {
      eyebrow: "لماذا نحن",
      title: "لماذا دنت إكسبرس؟",
      heritageLabel: "خبرة وموروث",
      heritageHeadline: "سنوات من التخصص في إزالة الضربات بدون صبغ في الكويت",
      heritageCopy:
        "أكثر من عقدين من الشغل الدقيق والصادق — متخصصون فقط في إزالة الضربات بدون صبغ مع المحافظة على صبغ الوكالة.",
      estLabel: "تأسسنا",
      points: [
        { t: "متخصصون في إزالة الضربات بدون صبغ", d: "تركيزنا الكامل على إزالة الضربات بدون إعادة صبغ." },
        { t: "نحافظ على صبغ الوكالة", d: "نحافظ على الصبغ الأصلي كلما كانت الحالة مناسبة." },
        { t: "تقييم سريع عبر واتساب", d: "أرسل صور واضحة واحصل على رأي صريح بسرعة." },
        { t: "ورشة نظيفة واحترافية", d: "ورشة منظمة في الشويخ مجهزة للعمل الدقيق." },
        { t: "فنيون بخبرة عالية", d: "أيدي ماهرة مدربة على تقنيات PDR الحديثة." },
        { t: "موثوقون في الكويت منذ 2005", d: "عقدان من العمل الدقيق والصادق لسائقي الكويت." },
      ],
    },
    services: {
      eyebrow: "خدماتنا",
      title: "خدماتنا",
      items: [
        { t: "إزالة الضربات بدون صبغ", d: "إصلاح الضربات بدون إعادة صبغ عند إمكانية ذلك.", icon: "Hammer" },
        { t: "ضربات الأبواب", d: "الضربات الصغيرة في المواقف، بدون لمس الصبغ.", icon: "Car" },
        { t: "الضربات الخفيفة", d: "ضربات خفيفة على الأبواب والرفارف والبودي.", icon: "CircleDot" },
        { t: "ضربات المواقف", d: "ضربات عربات التسوق والأبواب والصدامات — تصليح بدون صبغ.", icon: "ParkingSquare" },
        { t: "ضربات البَرَد", d: "ضربات دائرية متعددة على جسم السيارة.", icon: "CloudHail" },
        { t: "تحسين مظهر السيارة قبل البيع", d: "نجهّز مظهر السيارة قبل بيعها.", icon: "Tag" },
        { t: "تقييم الضربة عن طريق الصور", d: "أرسل الصور على واتساب ونقيم بصراحة.", icon: "ImageDown" },
      ],
    },
    how: {
      eyebrow: "خطوات العمل",
      title: "طريقة العمل",
      steps: [
        { t: "أرسل صور واضحة", d: "أرسل صور واضحة للضربة على واتساب." },
        { t: "نقيّم بأمانة", d: "نقيّم إذا كان الإصلاح بدون صبغ ممكن." },
        { t: "زر الورشة أو احجز موعد", d: "زر الورشة أو احجز موعد مناسب." },
        { t: "نصلح بدون صبغ", d: "يتم إصلاح السيارة بدون صبغ إذا كانت الحالة مناسبة." },
      ],
    },
    gallery: {
      eyebrow: "أعمالنا",
      title: "قبل وبعد",
      case: "الحالة",
      before: "قبل",
      after: "بعد",
      dragHint: "اسحب للمقارنة",
      ctaLine: "عندك ضربة مشابهة؟ أرسل الصور للتقييم.",
      cta: "أرسل على واتساب",
      uploadingNote: "حالات إضافية قريباً — جاري رفع الصور.",
      casesLabel: "حالة حقيقية",
    },
    videos: {
      eyebrow: "فيديو",
      title: "نتائج الإصلاح",
      subtitle: "مقاطع قصيرة توضح خطوات الإصلاح والنتيجة النهائية.",
      caseLabel: "الحالة",
    },
    when: {
      eyebrow: "متى ينفع",
      title: "متى يكون الإصلاح بدون صبغ مناسب؟",
      copy: "إزالة الضربات بدون صبغ تكون أفضل إذا كان الصبغ سليم، والوصول للضربة ممكن، والضربة ليست حادة أو متمددة بشكل كبير. ليست كل الحالات يمكن إصلاحها 100٪، لكننا نقيّم الحالة بأمانة قبل البدء.",
      chips: ["الصبغ سليم", "الوصول ممكن", "ليست حادة", "غير متمددة"],
    },
    reviews: {
      eyebrow: "السمعة",
      title: "ماذا يقول عملاؤنا",
      subtitle: "موثوقون من أصحاب السيارات في الكويت.",
      verifiedBadge: "تقييمات حقيقية ٥ نجوم من Google",
      placeholderBadge: "بطاقة قابلة للتعديل",
      placeholderNote:
        "سيتم إضافة تقييمات Google الحقيقية بخمس نجوم هنا. البطاقات أدناه قابلة للتعديل فقط.",
      cta: "شاهد كل التقييمات على Google",
      placeholders: [
        { name: "عنصر مؤقت", text: "استبدل هذه البطاقة بتقييم حقيقي 5 نجوم من Google." },
        { name: "عنصر مؤقت", text: "استبدل هذه البطاقة بتقييم حقيقي 5 نجوم من Google." },
        { name: "عنصر مؤقت", text: "استبدل هذه البطاقة بتقييم حقيقي 5 نجوم من Google." },
      ],
    },
    location: {
      eyebrow: "زورونا",
      title: "زورونا في دنت إكسبرس",
      subtitle: "مركز ناصر، محل ٣٣، الشويخ، الكويت",
      hoursTitle: "أوقات العمل",
      todayLabel: "اليوم",
      closed: "مغلق",
      ramadanLabel: "مواعيد رمضان",
    },
    faq: {
      eyebrow: "أجوبة",
      title: "الأسئلة الشائعة",
      items: [
        { q: "ما هي إزالة الضربات بدون صبغ؟", a: "هي طريقة لإصلاح ضربات السيارة بدون إعادة صبغ القطعة، إذا كان الصبغ سليم وحالة الضربة مناسبة." },
        { q: "هل تحتاج السيارة إلى صبغ؟", a: "ليس دائماً. إذا كان الصبغ سليم والضربة مناسبة، غالباً يمكن إصلاحها بدون صبغ." },
        { q: "هل يمكن إصلاح كل الضربات؟", a: "لا. بعض الضربات تكون حادة أو متمددة أو فيها ضرر كبير. نحن نقيّم كل حالة بأمانة قبل البدء." },
        { q: "كم يستغرق الإصلاح؟", a: "يعتمد على حجم وعمق ومكان الضربة. كثير من الضربات الصغيرة يمكن إصلاحها بسرعة." },
        { q: "هل أستطيع إرسال الصور أولاً؟", a: "نعم. أرسل صور واضحة على واتساب رقم 55787747 وسنقوم بتقييم الحالة." },
        { q: "هل تصلحون الخدوش أم الضربات فقط؟", a: "تخصصنا هو إزالة الضربات بدون صبغ. الخدوش قد تحتاج لطريقة إصلاح مختلفة." },
      ],
    },
    quote: {
      eyebrow: "تقييم مجاني",
      title: "اطلب تقييم مجاني",
      subtitle:
        "خبرنا عن الضربة وأرفق الصور — بنراجع الحالة ونرد عليك بتقييم صريح.",
      nameLabel: "الاسم",
      namePh: "مثال: أحمد",
      phoneLabel: "رقم الهاتف / واتساب",
      phonePh: "مثال: 55787747",
      carLabel: "نوع وموديل السيارة",
      carPh: "مثال: تويوتا كامري 2022",
      descLabel: "وصف الضربة",
      descPh: "وين الضربة؟ وشكثر حجمها؟ (الباب، الرفرف، الكبوت...)",
      photosLabel: "صور الضربة (اختياري)",
      photosHint: "حتى ٣ صور، بحد أقصى ١٠ ميغابايت للصورة",
      addPhotos: "أضف صور",
      submit: "اطلب التقييم المجاني",
      submitting: "جاري الإرسال...",
      successTitle: "شكراً لك! تم استلام طلبك",
      successText: "بنراجع حالة الضربة ونتواصل معك قريباً. لأسرع رد، كمّل على واتساب:",
      continueWhatsApp: "كمّل على واتساب",
      newRequest: "أرسل طلب آخر",
      errorGeneric: "صار خطأ. حاول مرة ثانية أو تواصل معنا على واتساب.",
      errorPhotos: "تقدر ترفق حتى ٣ صور (بحد أقصى ١٠ ميغابايت للصورة).",
      requiredNote: "الاسم ورقم الهاتف مطلوبان.",
    },
    contact: {
      eyebrow: "ابدأ",
      title: "أرسل الصور للتقييم",
      subtitle: "أرسل لنا صور واضحة للضربة وسنقوم بتقييم الحالة.",
      instagram: "إنستغرام",
      shopLabel: "المحل",
    },
    footer: {
      tagline: "متخصصون في إزالة الضربات بدون صبغ في الكويت",
      rights: "جميع الحقوق محفوظة.",
    },
  },
};
